import { useEffect, useState } from 'react';
import { ml, translation } from 'src/_shared/services/utils';
import note from 'src/_shared/assets/note.png';

/**
 * Inline "Status Reason" box shown to employees in place of the hover-only
 * admin note icon when a referral is ineligible.
 */
const StatusReasonNote = ({ referral, currentUser, allMultiLingualData }) => {
	const adminNote = referral?.adminNote;
	const languageCode = currentUser?.languageCode;
	const [noteText, setNoteText] = useState(adminNote || '');

	useEffect(() => {
		let cancelled = false;
		if (!adminNote) {
			setNoteText('');
			return undefined;
		}

		if (languageCode && languageCode !== 'EN' && languageCode !== 'US') {
			translation(adminNote, { languageCode })
				.then((translated) => {
					if (!cancelled) setNoteText(translated || adminNote);
				})
				.catch((error) => {
					console.error(error);
					if (!cancelled) setNoteText(adminNote);
				});
		} else {
			setNoteText(adminNote);
		}

		return () => {
			cancelled = true;
		};
	}, [adminNote, languageCode]);

	if (!adminNote) return null;

	return (
		<div className="status-reason-note">
			<img className="status-reason-note-icon" alt="admin-note" src={note} />
			<div className="status-reason-note-body">
				<div className="status-reason-note-title">
					{ml('Status Reason', currentUser, allMultiLingualData)}
				</div>
				<div className="status-reason-note-text">{noteText}</div>
			</div>
		</div>
	);
};

export default StatusReasonNote;
